// Dependencies
import React from "react";

const Play = ({ width="64px", height="64px", color="#121923" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 800 800"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M336 240H272V560H336V240ZM528 240H464V560H528V240Z"
        fill={color}
      />
      <path
        d="M272 240V220.8H252.8V240H272ZM336 240H355.2V220.8H336V240ZM272 560H252.8V579.2H272V560ZM336 560V579.2H355.2V560H336ZM464 240V220.8H444.8V240H464ZM528 240H547.2V220.8H528V240ZM464 560H444.8V579.2H464V560ZM528 560V579.2H547.2V560H528ZM272 259.2H336V220.8H272V259.2ZM291.2 560V240H252.8V560H291.2ZM336 540.8H272V579.2H336V540.8ZM316.8 240V560H355.2V240H316.8ZM464 259.2H528V220.8H464V259.2ZM483.2 560V240H444.8V560H483.2ZM528 540.8H464V579.2H528V540.8ZM508.8 240V560H547.2V240H508.8Z"
        fill={color}
      />
    </svg>
  );
};

export default Play;
